
import {computed, defineComponent, onMounted, PropType, reactive, ref} from "vue";
import InputText from "primevue/inputtext";
import Message from 'primevue/message';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import {QueueEntry} from "@dex/squeeze-client-ts";

export default defineComponent({
	name: "QueueDeleteForm",
	components: {
		InputText, Message,
	},
	props: {
		showErrorMessage: {
			type: Boolean,
			default: false,
		},
		queueEntries: {
			type: Array as PropType<QueueEntry[]>,
			default: () => [],
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		const {t} = useI18n();
		const toast = useToast();

		/** Show loading? */
		const loading = ref(false);

		/** Current Object of all input-fields */
		const value = reactive<{ comment: string }>({
			comment: '',
		});

		/** Determines the required rules for validation */
		const rules = {
			comment: { required },
		}


		/** Text of the warning in Entry-Dialog */
		const warningText = computed(() => {
			if (props.queueEntries.length > 1) {
				return t('Squeeze.Queue.General.DeleteWarningMultiple');
			}
			return t('Squeeze.Queue.General.DeleteWarning');
		});

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(async () => {
			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		});

		/** Triggered on change of any field */
		const update = async () => {
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		}

		return {
			t,
			toast,
			warningText,
			loading,
			value,
			props,
			v$,
			update,
		}
	},
});

